import { render, staticRenderFns } from "./AtualizacoesCadastrais.vue?vue&type=template&id=3f5622cb&"
import script from "./AtualizacoesCadastrais.vue?vue&type=script&lang=js&"
export * from "./AtualizacoesCadastrais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports